export function defaultTicketView(user){
 return {showAll:user?.profile==="admin",queueIds:user?.profile==="admin"?[]:(user?.queues||[]).map(queue=>queue.id)};
}
export function ticketVisibleInList(ticket,user,showAll,selectedQueueIds=[]){
 if(!ticket||Number(ticket.companyId||user.companyId)!==Number(user.companyId))return false;
 const all=showAll&&(user.profile==="admin"||user.allUserChat==="enabled");
 const owner=!ticket.userId||Number(ticket.userId)===Number(user.id)||all;
 const allQueues=user.profile==="admin"&&selectedQueueIds.length===0;
 const noQueue=!ticket.queueId&&(user.profile==="admin"||user.allTicket==="enable");
 return owner&&(allQueues||noQueue||selectedQueueIds.map(Number).includes(Number(ticket.queueId)));
}
